import React from 'react'
import cx from 'classnames'
import { SvgIcon } from '../svg-icon'

/**
 * Stateless function representing a SortDirection icon (up-down triangle).
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SortDirectionIcon width={12} />
 */
export function SortDirectionIcon({ className, ...props }) {
    const composedClass = cx(className, 't3sel-sort-direction-icon')

    return (
        <SvgIcon viewBox="0 0 48 48" className={composedClass} {...props}>
            <path
                d="M22.64,46L8.57,32a1.92,1.92,0,0,1,1.36-3.27H38.08A1.92,1.92,0,0,1,39.43,32L25.36,
            46A1.92,1.92,0,0,1,22.64,46Z"
            />
            <path
                d="M25.36,2L39.43,16a1.92,1.92,0,0,1-1.36,3.27H9.92A1.92,1.92,0,0,1,8.57,16L22.64,
            2A1.92,1.92,0,0,1,25.36,2Z"
            />
        </SvgIcon>
    )
}
